import { withSession } from '@zipdrug/react-api-sdk';
import { get } from 'lodash';
import { graphql } from '@apollo/client/react/hoc';
import fetchOnceOptions from './utils/fetchOnceOptions';
import { queryCurrentUser } from '../graphql/users';

export default function withCurrentUser(Component) {
  const ComponentWithData = graphql(queryCurrentUser, {
    // Include the user id in the cache key since it is not part of variables
    skip: ({ userId }) => !userId,
    options: ({ userId }) => fetchOnceOptions(`currentUser_${userId}`, {}, true),
    props: ({ data, ownProps }) => ({
      ...ownProps,
      currentUser: get(data, 'currentUser.data'),
      loadingCurrentUser: data?.loading || false,
    }),
  })(Component);

  return withSession(ComponentWithData);
}
